import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import {
  loginMarketingContentSx,
  loginMarketingCopyBlockSx,
  loginMarketingHeadlineBlockSx,
  loginMarketingHeadlineLineSx,
  loginMarketingHeadlineSecondBlockSx,
  loginMarketingHeadlineStrategicSx,
  loginMarketingIllustrationPositionSx,
  loginMarketingIllustrationWrapSx,
  loginMarketingPanelBodySx,
  loginMarketingPanelSx,
  loginMarketingSubtitleSx,
} from '../styles/loginMarketingStyles'
import { LoginIllustration } from './LoginIllustration'

/** Figma 5074-11767 / 5074-11768 — left marketing column. */
export function LoginMarketingPanel() {
  return (
    <Box data-testid="login-marketing-panel" sx={loginMarketingPanelSx}>
      <Box data-testid="login-marketing-body" sx={loginMarketingPanelBodySx}>
        <Box data-testid="login-marketing-content" sx={loginMarketingContentSx}>
          <Box
            data-testid="login-marketing-illustration-wrap"
            sx={loginMarketingIllustrationWrapSx}
          >
            <LoginIllustration sx={loginMarketingIllustrationPositionSx} />
          </Box>

          <Box data-testid="login-marketing-copy" sx={loginMarketingCopyBlockSx}>
            <Box data-testid="login-marketing-headline" sx={loginMarketingHeadlineBlockSx}>
              <Typography component="p" sx={loginMarketingHeadlineLineSx}>
                Turn
              </Typography>
              <Box sx={loginMarketingHeadlineSecondBlockSx}>
                <Typography component="p" sx={loginMarketingHeadlineLineSx}>
                  Signals Into
                </Typography>
                <Typography component="p" sx={loginMarketingHeadlineStrategicSx}>
                  {`Strategic\nDecisions`}
                </Typography>
              </Box>
            </Box>

            <Typography component="p" sx={loginMarketingSubtitleSx}>
              Collect real-world signals, uncover hidden patterns, and make confident
              decisions with AI-powered intelligence.
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
